module.exports = __webpack_public_path__ + "img/IMG_20220216_134229527.031b1181.jpg";